import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../../services/event.service';
import { ExternalpageService } from '../../../services/externalpage.service';
import { StripHtmlPipe } from '../../../../pipe/pipe.striphtml';
import { group_by_item_count } from '../../../../functions';

@Component({
  selector: 'app-home-events-section',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, NgbCarouselModule, StripHtmlPipe],
  templateUrl: './home-events-section.component.html',
})
export class HomeEventsSectionComponent {
  events: any[] = [];

  eventSlider = {
    slides_desktop: [] as any[],
    slides_mobile: [] as any[],
  };

  constructor(
    public eventService: EventService,
    public externalpageService: ExternalpageService,
  ) {
    this.eventService.setHomeData();

    this.events = this.eventService.homeData;
    if (!this.events || this.events.length === 0) {
      this.eventService.$homeDataSubject.subscribe(() => {
        this.events = this.eventService.homeData;
        this.eventSlider.slides_desktop = group_by_item_count(this.events, 3);
        this.eventSlider.slides_mobile = group_by_item_count(this.events, 1);
      });
    } else {
      this.eventSlider.slides_desktop = group_by_item_count(this.events, 3);
      this.eventSlider.slides_mobile = group_by_item_count(this.events, 1);
    }
  }
}
